import { useProsMirrorNode } from '../../../../context/ProseMirrorNodeProvider';
import { isLastNode } from '../../../../context/VideoOverlayProvider/utils';
import { useNextLesson } from '../../../../hooks/useNextLesson';
import { useQuizContextProvider } from '../../context/QuizBlockContext';

export const useCourseQuizNextLesson = () => {
  const { onNextLessonClick, isNextLessonAvailable: _isNextLessonAvailable } = useNextLesson();
  const { node } = useProsMirrorNode();
  const { quizBlockId } = useQuizContextProvider();
  const isLast = isLastNode(node, quizBlockId);

  const isNextLessonAvailable = _isNextLessonAvailable && isLast;

  return { isNextLessonAvailable, onNextLessonClick };
};
